module.exports = __webpack_public_path__ + "img/cheese.b5d4cbce.png";